import { Config } from "@/shared/config";
import { AppInfo, DevicePlatform } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";

const cordova = (window as any).cordova;
const capacitor = (window as any).Capacitor;

export function isMobileApp () {
    return !!Config.Mobile.AppId;
}

export function getAuthType () {
    return Config.Mobile.AuthType;
}

export const NativePlatform = () => {
    if (capacitor && capacitor.getPlatform()) {
        return capacitor.getPlatform().toLowerCase();
    }
    if (cordova && cordova.platformId) {
        return cordova.platformId.toLowerCase();
    }
    return "";
};

const getDevicePlatform = (): DevicePlatform => {
    const platform = NativePlatform();
    if (platform === "android") return DevicePlatform.Android;
    if (platform === "ios") return DevicePlatform.iOS;
    return DevicePlatform.Unknown;
};

export const mobileAppInfo = (): AppInfo => {
    return {
        platform: getDevicePlatform(),
        name: Config.Mobile.AppName,
        version: Config.Mobile.AppVersion,
        isMobile: true
    };
};

export const mobilePlugins = capacitor && capacitor.Plugins;

/**
 * The target in which to load the URL
 */
export enum AppBrowserTarget {
    /** Opens in the Cordova WebView if the URL is in the white list, otherwise it opens in the InAppBrowser. */
    self = "_self",
    /** opens in the InAppBrowser */
    blank = "_blank",
    /** opens in the system's web browser */
    system = "_system"
}

/**
 * mobileHelper/openUrl
 * @param url string
 * @param target enum: AppBrowserTarget
 * @param options(optional) string. Example: "location=yes,hideurlbar=yes,toolbarposition=top,fullscreen=no".
 * For more information: https://cordova.apache.org/docs/en/10.x/reference/cordova-plugin-inappbrowser/
 */
export function openUrl (url: string, target: AppBrowserTarget, options = ""): void {
    const inAppBrowserRef = cordova.InAppBrowser.open(url, target, options);

    // event fires when the InAppBrowser finishes loading a URL
    inAppBrowserRef.addEventListener("loadstop", loaded);
    // event fires when the InAppBrowser window is closed.
    inAppBrowserRef.addEventListener("exit", exited);

    function loaded () {
        const userStore = useUserStore();
        userStore.activeUserPing();
    }

    function exited () {
        inAppBrowserRef.removeEventListener("loadstop", loaded);
        inAppBrowserRef.removeEventListener("exit", exited);
    }
}

export function isCapacitorAvailable (): boolean {
    return capacitor && capacitor !== undefined;
}
